import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MissingDriverDocumentEntity } from '../../domain/entities/MissingDriverDocumentEntity'

export class MissingDriverDocumentModel extends MissingDriverDocumentEntity {
  constructor(dataDto: MissingDriverDocumentModel) {
    super()
    mapEntityProperties<MissingDriverDocumentEntity>(this, dataDto)
  }
}
